import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const SessionTimeoutPopup = () => {
  const { sessionTimeout, setSessionTimeout } = useContext(languageContext);
  const navigate = useNavigate();
  const location = useLocation();

  // const Close = () => {
  //   setSessionTimeout(false);
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("login");
  //   setTimeout(() => {
  //     navigate("/login");
  //   }, 500);
  // };'
  const Close = async (patientId) => {
    setSessionTimeout(false);
  
    try {
      const token = localStorage.getItem("token");
  
      // Call backend API to delete cache
      await axios.post(
        "https://www.dev.careplus.gopillz.com/delete_cache_alert",  // Replace with your actual endpoint
        { patient_id: localStorage.getItem("patient_id") },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
    } catch (error) {
      console.error("Failed to delete cache:", error);
      // Optional: Show an error message
    }
  
    // Clear local storage and redirect
    localStorage.removeItem("token");
    localStorage.removeItem("login");
  
    setTimeout(() => {
      navigate("/login");
    }, 500);
  };


  // Do not show the popup on login or signup pages
  if (location.pathname === "/login" || location.pathname === "/signup") {
    return null;
  }

  return (
    <>
      {sessionTimeout && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h2 className="text-xl font-bold mb-4">Session Timeout</h2>
            <p>
              You have been snoozed as you went missing. This is for your safety
              and security. Please login with your mobile number again
            </p>
            <div className="mt-6 flex justify-end">
              <button
                className="bg-bluebtn text-white py-2 px-4 rounded-lg"
                onClick={Close}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionTimeoutPopup;
